import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { Company } from 'resources/types'

export const LS_KEY = 'selectedCompany'            // stores full object JSON
export const QK = ['selectedCompany'] as const     // query key for full object

export function useSelectedCompany() {
	const qc = useQueryClient()

	// Load once from localStorage; keep in Query forever
	const { data: currentCompany } = useQuery({
		queryKey: QK,
		queryFn: async () => {
			const raw = localStorage.getItem(LS_KEY)
			return raw ? (JSON.parse(raw) as Company) : undefined
		},
		staleTime: Infinity,
		gcTime: Infinity,
		initialData: () => {
			const raw = localStorage.getItem(LS_KEY)
			return raw ? (JSON.parse(raw) as Company) : undefined
		},
	})

	// Set or clear by full object
	const setCurrentCompany = useMutation({
		mutationFn: async (company: Company | undefined) => {
			if (company) localStorage.setItem(LS_KEY, JSON.stringify(company))
			else localStorage.removeItem(LS_KEY)
			return company
		},
		onSuccess: (company) => {
			qc.setQueryData(QK, company)
			// Optional: invalidate company-scoped queries here
			// qc.invalidateQueries({ queryKey: ['companyScoped'] })
		},
	})

	const clearCurrentCompany = useMutation({
		mutationFn: async () => {
			localStorage.removeItem(LS_KEY)
			return undefined as Company | undefined
		},
		onSuccess: () => {
			qc.setQueryData(QK, undefined)
		},
	})

	return {
		currentCompany: currentCompany as Company | undefined,
		setCurrentCompany,      // setSelectedCompany.mutate(companyObj or undefined)
		clearCurrentCompany,    // clearSelectedCompany.mutate()
	}
}
